/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */
import {Component, EventEmitter, HostBinding, Injectable, Input} from '@angular/core';

import {AuthenticationEvent, AuthenticationService} from '../../../shared/authentication/authentication.service';

/**
 * Tag interface for the Dropdown component.
 */
interface Dropdown {
}

/**
 * Helper service that streams dropdown when they are activated. Useful for other dropdown upon such events.
 */
@Injectable()
export class MenuDropdownService {
  public dropdownActivated: EventEmitter<Dropdown> = new EventEmitter();
}

/**
 * Our dropdown component that implements the dropdown behavior : opens up when clicked once, closes when clicked a
 * second time or when another dropdown gets opened up.
 */
@Component({
  selector: '[gp-menu-dropdown]',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent implements Dropdown {

  @Input()
  public icon: string;

  @Input()
  public testId: string;

  @Input()
  public name: string;

  @Input()
  public dropdownActive: boolean = false;

  @HostBinding('class.active')
  public get active() {
    return this.dropdownActive;
  }

  constructor(
    private service: MenuDropdownService,
    private authenticationService: AuthenticationService
  ) {
    this.service.dropdownActivated.subscribe(component => {
      if (component !== this) {
        // Upon another dropdown being toggled, close this one
        this.dropdownActive = false;
      }
    });
    this.authenticationService.authenticationEvents.subscribe(result => {
      if (result.event === AuthenticationEvent.LOGOUT) {
        // Upon logout, deactivate any sub-menu dropdown
        this.dropdownActive = false;
      }
    });
  }

  public toggle() {
    this.dropdownActive = !this.dropdownActive;
    this.service.dropdownActivated.emit(this);
  }
}
